import React from "react";
import Skeleton from "@mui/material/Skeleton";

export const MainPageLoader = () => {
  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex" }}>
        <Skeleton animation="wave" variant="text" width={200} height={100} />
        <div style={{ width: "80%" }}></div>
        <Skeleton animation="wave" variant="text" width={100} height={100} />
      </div>
      <div style={{ height: 10 }}></div>
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <Skeleton animation="wave" variant="text" width="100%" height={50} />
      <div style={{ display: "flex" }}>
        <Skeleton animation="wave" variant="text" width={200} height={100} />
        <div style={{ width: "80%" }}></div>
        <Skeleton animation="wave" variant="text" width={100} height={100} />
      </div>
    </div>
  );
};
